module.exports = __webpack_public_path__ + "img/badge-list-thumb-033.9863c65d.png";